import SignatureCanvas from "react-signature-canvas";
import { useRef } from "react";

export default function SignaturePad({ setSignatureData }) {
	const sigCanvas = useRef();
	const clear = () => {
		sigCanvas.current.clear();
		setSignatureData(null);
	};

	const handleEnd = () => {
		const dataURL = sigCanvas.current.toDataURL("image/png");

		setSignatureData(dataURL);
	};

	return (
		<div className="w-full ">
			<div className="border border-black w-full ">
				<SignatureCanvas penColor="black" canvasProps={{ height: 200, className: "sigCanvas w-full" }} ref={sigCanvas} onEnd={handleEnd} />
			</div>
			<div className="flex justify-end mt-1">
				<button onClick={clear} className="border border-black p-2">
					Clear
				</button>
			</div>
		</div>
	);
}
